import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router'
import { Subject, BehaviorSubject, AsyncSubject, Observable } from 'rxjs';
import { SecureStorageService } from './../../utilities/secure-storage.service';

@Injectable({ providedIn: 'root' })
export class InterApplicationCommunicationService {

    constructor(private secureStorageService: SecureStorageService, private appMetadataHandler: AppMetadataHandler) { }


    sendDataToTargetApplication(url, data) {
        let targetWindow = window.open(url, '');
        targetWindow.postMessage(data, url); //sending the data to target application
    }

    // this function has to be placed/called in thread service inside application bootstrap hook
    fetchDataFromSourceApplication(lsKey, strictMode?) {
        if (lsKey) {
            window.addEventListener('message', (e) => {
                var origin = e.origin;
                var parentData = JSON.parse(e.data);
                this.setDataInLocalStorage(lsKey, JSON.stringify(parentData))

                // if ((strictMode && this.appMetadataHandler.allowedInterCommunicationApps.includes(origin)) || !strictMode) {
                //     this.setDataInLocalStorage(lsKey, JSON.stringify(parentData))
                // } else {
                //     console.error("Invalid origin", origin);
                // }
            }, false);
        } else
            throw 'Local Storage Key required';
    }

    setDataInLocalStorage(key, data) {
        this.secureStorageService.set(key, data);
    }

    getDataFromLocalStorage(key) {
        try {
            return JSON.parse(this.secureStorageService.get(key));
        } catch{
            console.error("Error in fetching data from local storage");
        }
    }

}